import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationService } from '@core/services/notification.service';
import { NzUploadFile } from 'ng-zorro-antd/upload';

@Component({
  selector: 'app-upload-picture-wall',
  templateUrl: './upload-picture-wall.component.html',
  styleUrls: ['./upload-picture-wall.component.scss']
})
export class UploadPictureWallComponent implements OnInit {

  fileList: NzUploadFile[] = [];
  previewVisible = false;
  previewImage: any;

  constructor(
    private sanitizer: DomSanitizer,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
  }

  handlePreview = async (file: NzUploadFile): Promise<void> => {
    this.previewImage = file.url;
    this.previewVisible = true;

    // if (file.id) {
    //   this.uploadService.consultarPorId(file.id).subscribe(
    //     (val: any) => {
    //       val.subscribe((base64String: string) => {
    //         file.url = base64String;
    //         this.previewImage = file.url;
    //         this.previewVisible = true;
    //       });
    //     },
    //     (err: any) => {
    //       this.previewVisible = false;
    //     }
    //   );
    // }
  };

  beforeUpload = (file: any): boolean => {
    const allowedExtensions = ['.jpg', '.jpeg', '.png'];
    const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      this.notificationService.warn('Atenção!', 'Tipo de arquivo não permitido. Por favor, selecione um arquivo do tipo imagem.');
      return false;
    }

    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e: any) => {

      const arquivo: any = {};
      arquivo.base64Content = e.target?.result?.toString().split(',')[1];

      let imagem = new Image();
      imagem.src = e.target?.result;
      imagem.onload = () => {
        file.url = `data:text/html;base64,${arquivo.base64Content}`;
        file.arquivo = arquivo.base64Content;
        this.fileList = [file];

        console.log(this.fileList)
        // this.uploadService.upload(file).subscribe((res: any) => {
        //   file.id = res.id;
        //   this.fileList = [...this.fileList, file];
        // })
      }
    }
    return false;
  };
}
